// extracted by mini-css-extract-plugin
module.exports = {"title":"TimeLineBarLink_title__2lJIm","subtitle":"TimeLineBarLink_subtitle__1_Pte","menu-item":"TimeLineBarLink_menu-item__1yZvb","list-item":"TimeLineBarLink_list-item__2EnY3"};